// Slider config moved to: assets/js/components/ui-components/slick-slider.js (preset "about-story")
// Template updated: templates/public/static/about-us-landing.html.twig (data-lazy-init="slick-slider")

const initVideoModals = () => {
  $(document).on("show.bs.modal", ".modal[id^='modal__']", function () {
    const $iframe = $(this).find("iframe");
    const src = $iframe.data("src");
    if (src && !$iframe.attr("src")) {
      $iframe.attr("src", src);
    }
  });

  $(document).on("hide.bs.modal", ".modal[id^='modal__']", function () {
    $(this).find("iframe").attr("src", "");
  });
};

document.addEventListener("DOMContentLoaded", () => {
  initVideoModals();
});
